var cx1 = require("./118.js");
module.exports = function (cwY, cwZ, cx0, cx5, cx6) {
  var cx7 = new Error(cwY);
  return cx1(cx7, cwZ, cx0, cx5, cx6);
};